import React from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';

import { formatNull, formatDate } from '../../Utils/GlobalUtils';
import { useTimeModal } from '../TimeModal/TimeModalContext';

import AddNewSpecialDebtorCategory from './Components/AddNewSpecialDebtorCategory';
import DeleteSDC from './Components/DeleteSDC';

import Loading from '../Loading';
import LoadingLines from '../LoadingLines';
import WarningPanel from '../WarningPanel';

import IconContainer from '../IconContainer';
import { ReactComponent as ReloadIcon } from '../../icons/reload.svg';
import { ReactComponent as TrashIcon } from '../../icons/trash.svg';
import { ReactComponent as CommentRedoIcon } from '../../icons/comment-redo.svg';

const SpecialDebtorCategories = () => {
  const { openTimeModal } = useTimeModal;
  const navigate = useNavigate();
  const location = useLocation();

  const [cases, setCases] = React.useState([]);
  const [warning, setWarning] = React.useState('');
  const [reload, setReload] = React.useState(true);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const token = localStorage.getItem('token');

    setLoading(true);

    axios.get(`/api/get-special-debtor-categories`, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    })
    .then((response) => {
      setWarning('');
      setCases(response.data);
    })
    .catch((error) => {
      setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
    })
    .finally(() => {
      setReload(false);
      setLoading(false);
    });
  }, [reload]);

  const handleChangeIsActive = (id) => {
      const token = localStorage.getItem('token');

      setLoading(true);
  
      axios.put(`/api/change-is-active-special-debtor-category/${id}`, {
          headers: {
              Authorization: `Bearer ${token}`,
          }
      })
      .then(() => {
          setReload(true);
          setConfirmDeleteId(null);
      })
      .catch((error) => {
          openTimeModal(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`, 'error');
      });
  };

  const [confirmDeleteId, setConfirmDeleteId] = React.useState(null);
    
  React.useEffect(() => {
    if (confirmDeleteId !== null) {
      const timeout = setTimeout(() => setConfirmDeleteId(null), 3000);
      return () => clearTimeout(timeout);
    }
  }, [confirmDeleteId]);

  const [isModal, setIsModal] = React.useState(false);
  const [isDeleteModal, setIsDeleteModal] = React.useState(false);
  const [currentId, setCurrentId] = React.useState('');


  return (
    <>
        {isModal && <AddNewSpecialDebtorCategory closeModal={() => setIsModal(false)} onReloadTable={() => setReload(true)} />}
        {isDeleteModal && <DeleteSDC closeModal={() => setIsDeleteModal(false)} handleChangeIsActive={() => handleChangeIsActive(currentId)} />}

        <div className='tableContainer'>
            <div className='tableHeaderWrapper'>
            <div className='tableStatus'>
                <div>
                <button type='button' className='secondaryButton' onClick={() => setIsModal(true)}>
                    <svg viewBox="0 0 24 24" id="plus" fill="currentColor">
                    <path d="M19,11H13V5a1,1,0,0,0-2,0v6H5a1,1,0,0,0,0,2h6v6a1,1,0,0,0,2,0V13h6a1,1,0,0,0,0-2Z"></path>
                    </svg>
                    Добавить категорию
                </button>
                </div>
                <a className='lastUpdateWrapper'>
                    {loading ? 
                        <Loading type='inline' /> 
                    : 
                        <IconContainer Icon={ReloadIcon} onClick={() => setReload(true)} size = '14' color = 'black' className = '' />
                    }
                </a>
            </div>
            <div className='tableHeader' style={{ gridTemplateColumns: '1fr auto' }}>
                <div>Название</div>
                <div></div>
            </div>
            </div>
            {(cases.length==0 && loading) ? <LoadingLines />
            : warning ? <WarningPanel text={warning} inTable={true} buttonText='Обновить' buttonAction={() => setReload(true)} />
            : cases.map((caseItem) => (
                <div 
                  className='tableRow nonActive' 
                  style={{ gridTemplateColumns: '1fr auto' }}
                  key={caseItem.id}
                >
                  <div>
                    <p style={!caseItem.is_active ? { opacity: '0.7' } : undefined}>{formatNull(caseItem.category_name)} {!caseItem.is_active && '[Не учитывается]'}</p>
                  </div>
                  <div>
                    {caseItem.is_active ? 
                      (confirmDeleteId === caseItem.id ?
                        <button className='tableButton red' onClick={() => {setIsDeleteModal(true); setCurrentId(caseItem.id)}}>Не учитывать?</button>
                      :
                      <IconContainer Icon={TrashIcon} onClick={() => setConfirmDeleteId(caseItem.id)} size='16' color='red' className='' />
                      )
                    : 
                      (confirmDeleteId === caseItem.id ?
                        <button className='tableButton blue' onClick={() => {handleChangeIsActive(caseItem.id)}}>Снова учитывать?</button>
                      :
                      <IconContainer Icon={CommentRedoIcon} onClick={() => setConfirmDeleteId(caseItem.id)} size='16' color='blue' className='' />
                      )}
                  </div>
                </div>
            ))}
        </div>
    </>
  )
}

export default SpecialDebtorCategories;